<template>
  <ui-dialog
    :show="isOpen"
    :title="$t('message.photos.list.delete.title').toString()"
    :closable="false"
    persistent
    scrollable
    custom-class="photo-delete-dialog"
    @input="close"
  >
    <p>{{ $t("message.photos.list.delete.body1") }}</p>
    <p>{{ $t("message.photos.list.delete.body2") }}</p>
    <template #actions>
      <div class="d-flex justify-center mx-auto">
        <ui-button outlined @click="cancel" class="mr-5">
          {{ $t("message.common.cancel") }}
        </ui-button>
        <ui-button color="primary" :loading="loading" @click="confirm">
          {{ $t("message.photos.list.delete.confirm") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import serviceHandler from "@/helpers/handlers/service";
import photosService from "@/services/photos";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "PhotoDeleteDialog",
  props: {
    photoId: {
      type: Number,
      required: true
    },
    numLocations: {
      type: Number,
      required: true
    },
    publishDate: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      loading: false
    };
  },
  mounted() {
    this.isOpen = true;
  },
  methods: {
    async deletePhoto() {
      this.loading = true;
      await serviceHandler(photosService.deletePhoto(this.photoId));
      this.loading = false;
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.BULK_PHOTO_DELETE,
        photo_id: this.photoId,
        num_locations: this.numLocations,
        publish_date: this.publishDate
      });
    },
    close() {
      this.isOpen = false;
      this.$emit("close");
      setTimeout(() => {
        this.$destroy();
      }, 200);
    },
    async confirm() {
      await this.deletePhoto();
      this.$emit("confirm");
      this.close();
    },
    cancel() {
      this.$emit("cancel");
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.photo-delete-dialog {
  p {
    text-align: center;
    @include font-size(14px);
    line-height: 17px;
  }

  p ~ p {
    margin-top: $spacing * 4;
  }
}
</style>
